import { render, staticRenderFns } from "./BoatItemListDetails.vue?vue&type=template&id=2f7ae541&scoped=true&"
import script from "./BoatItemListDetails.vue?vue&type=script&lang=js&"
export * from "./BoatItemListDetails.vue?vue&type=script&lang=js&"
import style0 from "./BoatItemListDetails.vue?vue&type=style&index=0&id=2f7ae541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ae541",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VListItem,VRow,VTextField})
